export const FETCH_SAMPLE_COLLECTED_ORDERS_REQUEST = "FETCH_SAMPLE_COLLECTED_ORDERS_REQUEST";
export const FETCH_SAMPLE_COLLECTED_ORDERS_SUCCESS = "FETCH_SAMPLE_COLLECTED_ORDERS_SUCCESS";
export const FETCH_SAMPLE_COLLECTED_ORDERS_FAILURE = "FETCH_SAMPLE_COLLECTED_ORDERS_FAILURE";
